export default {
  menu: {
    sports: "Esportes",
    referAndEarn: "Indique e Ganhe",
    referDesc: "até 60% de comissão",
    copyLink: "Copiar Link",
    hot: "Populares",
    favorites: "Favoritos",
    recent: "Recentes",
    vipClub: "VIP Clube",
    bonus: "Bônus",
    bonusGames: "Jogos Bônus",
    affiliate: "Afiliado",
    promotion: "Promoção",
    rewards: "Recompensas",
    help: "Ajuda",
    feedback: "Feedback",
    downloadApp: "Baixar App",
    claimBonus: "Resgatar Bônus",
    redeemCode: 'Resgatar Código',
    redeemDesc: 'Resgate Sua Recompensa Grátis',
    liveSupport: "Suporte ao Vivo",
    language: "Idioma",
	search: "search"
  }
}
